export default "__VITE_ASSET__Cq7T9TwW__"